import { Typography } from "@mui/material";
import ColumnContainer from "../ColumnContainer";
import ModalComponent from "../ModalComponent";
import RowContainer from "../RowContainer";
import { DashboardButton } from "../DashboardButton";
import { FormattedMessage } from "react-intl";

const InfoModalComponent = ({
  className = [],
  openModal,
  handleCloseModal,
  confirmButton,
  handleConfirm,
  children,
}) => {
  const classNames = [...className, "confirm-credit-modal"].join(" ");
  return (
    <ModalComponent
      open={openModal}
      handleClose={handleCloseModal}
      className={classNames}
    >
      <ColumnContainer center align="center" padding="30px">
        {children}
        <RowContainer align="center" end minGap sx={{ alignSelf: "end" }}>
          <DashboardButton type="outlined" onClick={handleCloseModal}>
            <FormattedMessage id="button.back" />
          </DashboardButton>
          {confirmButton ? (
            <DashboardButton type="filled" onClick={handleConfirm}>
              <FormattedMessage id="button.confirm" />
            </DashboardButton>
          ) : null}
        </RowContainer>
      </ColumnContainer>
    </ModalComponent>
  );
};
export default InfoModalComponent;
